import cards from '../cards/locales';
import common from '../components/locales/index';
import kemtai from '../integrations/locales';
import en from './en.json';
import es from './es.json';
import de from './de.json';
import cs from './cs.json';
import ja from './ja.json';
import sk from './sk.json';

export default {
  en: {
    ...cards.en,
    ...common.en,
    ...kemtai.en,
    ...en,
  },
  es: {
    ...cards.es,
    ...common.es,
    ...kemtai.es,
    ...es,
  },
  de: {
    ...cards.de,
    ...common.de,
    ...kemtai.de,
    ...de,
  },
  cs: {
    ...cards.cs,
    ...common.cs,
    ...kemtai.cs,
    ...cs,
  },
  ja: {
    ...cards.ja,
    ...common.ja,
    ...kemtai.ja,
    ...ja,
  },
  sk: {
    ...cards.sk,
    ...common.sk,
    ...kemtai.sk,
    ...sk,
  },
};
